module.exports = __webpack_public_path__ + "media/images/icons/email-0144d91a0aef229ae1e7e36e1efd83e2.png";